import { Trophy, Gift, Banknote } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const prizes = [
  { icon: Trophy, count: "1×", title: "7 Jahre Steuererklärung gratis", note: "Der Hauptpreis: sieben Steuerjahre (2027–2033) für deinen Haushalt.", big: true },
  { icon: Gift, count: "20×", title: "Steuererklärung 2027 gratis", note: "Eine professionelle Steuererklärung für das Jahr 2027.", big: false },
  { icon: Banknote, count: "5×", title: "CHF 100 Cash", note: "Direkt und unkompliziert.", big: false },
];

export const Prizes = () => (
  <section id="gewinne" className="scroll-mt-20 bg-offwhite py-16 md:py-24" data-testid="prizes-section">
    <div className="mx-auto max-w-[1180px] px-5">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold-dark">Gewinnstruktur</p>
        <h2 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-ink md:text-5xl">
          26 echte Gewinner.
        </h2>
        <p className="mt-4 max-w-2xl text-base text-mutedlight">
          Mehrere Chancen zu gewinnen – bereits während der Kampagne werden jede Woche Gewinner gezogen.
        </p>
      </Reveal>
      <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3">
        {prizes.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.1}>
            <div
              className={`h-full rounded-[18px] border p-7 transition-transform duration-300 hover:-translate-y-1 ${
                p.big
                  ? "border-gold/50 bg-ink text-offwhite shadow-[0_16px_40px_rgba(17,17,17,0.15)]"
                  : "border-line bg-white shadow-[0_10px_30px_rgba(17,17,17,0.06)]"
              }`}
              data-testid={`prize-card-${i + 1}`}
            >
              <p.icon className={`h-7 w-7 ${p.big ? "text-gold" : "text-gold-dark"}`} strokeWidth={1.75} />
              <p className={`mt-4 font-display text-4xl font-extrabold tracking-tight ${p.big ? "text-gold" : "text-ink"}`}>{p.count}</p>
              <h3 className={`mt-1 font-display text-lg font-bold ${p.big ? "text-offwhite" : "text-ink"}`}>{p.title}</h3>
              <p className={`mt-2 text-sm leading-relaxed ${p.big ? "text-offwhite/70" : "text-mutedlight"}`}>{p.note}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
